import React from "react";
import styled from "styled-components";
import { theme } from "styles/theme";

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: ${theme.colors.textPrimary};
`;

interface FormLabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  htmlFor: string;
  children: React.ReactNode;
}

export function FormLabel({ htmlFor, children, ...props }: FormLabelProps) {
  return (
    <Label htmlFor={htmlFor} {...props}>
      {children}
    </Label>
  );
}
